import React, { useState } from 'react';

import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import ImportCountDefault from '@/components/Base/ImportCountDefault';
import TableHeaderCustom from '@/components/Base/TableHeaderCustom';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import { TitlePages } from '@/components/Base/TitlePage';

import TableIndixeConfigAvancadas from './TableIndixeConfigAvancadas';
import { useConfigAvancadas } from '@/features/indice-valor/api/getConfigAvancadas';
import LoadingChart from '@/features/dashboard/components/LoadingChart';

export const TableHeaderCustomIndice = ({ routeBack }) => {
  const generateLastYears = (numYears) => {
    const currentYear = dayjs().year();
    return Array.from({ length: numYears }, (_, index) => currentYear - index).reverse();
  };

  const [open, setOpen] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [listYears, setListYears] = useState(generateLastYears(5));

  const daysDiff = dayjs(selectedEndDate).diff(dayjs(selectedStartDate), 'day') || null;

  const filters = {
    ...(selectedYear && { year: selectedYear }),
    ...(selectedMonth && { month: selectedMonth }),
    ...(daysDiff !== null && { days: daysDiff }),
  };

  const { data: contasReceberGrafico, isFetching, isFetched } = useConfigAvancadas();

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  const onApplyFilter = (selectedYear: number) => {
    setOpen(!!selectedYear);
  };

  return (
    <>
      <ImportCountDefault open={open} handleClose={handleClose} />

      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Stack flexDirection={'row'} alignItems={'center'}>
          <ArrowBack sx={{ cursor: 'pointer' }} onClick={() => navigate(routeBack)} />
          <TitlePages title={'Índice de valor'} />
        </Stack>
      </Stack>
      <LoadingChart loading={isFetching} />
      {isFetched && (
        <Box
          padding={'15px'}
          sx={{
            border: '1px solid rgba(176, 176, 176, 1)',
            background: '#fff',
            borderRadius: '14px',
          }}
        >
          <TableIndixeConfigAvancadas data={contasReceberGrafico} />
        </Box>
      )}
    </>
  );
};
